// extracted by mini-css-extract-plugin
export default {"wrapper":"Gallery_wrapper__pTSGA","content":"Gallery_content__IrWls","scroll":"Gallery_scroll__-WsAE"};